<template>
  <section class="resume-section" id="skills">
    <div class="resume-section-content">
      <h2 class="mb-5">Skills</h2>
      <div class="subheading mb-3">Programming Languages & Tools</div>
      <ul class="list-inline dev-icons" v-if="skills.isLoading">
        <CodeLoader />
      </ul>
      <ul class="list-inline dev-icons" v-else>
        <li
          class="list-inline-item"
          v-for="(programming, index) in skills.programmingLanguages"
          :key="programming.id"
          :style="`${index <= 7 ? 'display: true' : 'display: none'}`"
        >
          <i :class="programming.icon"></i>
        </li>
        <br />
        <li
          class="list-inline-item"
          v-for="(programming, index) in skills.programmingLanguages"
          :key="programming.id"
          :style="`${index > 7 ? 'display: true' : 'display: none'}`"
        >
          <i :class="programming.icon"></i>
        </li>
      </ul>

      <div class="subheading mb-3">Workflow</div>
      <ul class="fa-ul mb-0" v-if="skills.isLoading">
        <BulletListLoader />
      </ul>
      <ul class="fa-ul mb-0" v-else>
        <li v-for="workflow in skills.workflows" :key="workflow">
          <span class="fa-li"><i class="fas fa-check"></i></span>
          {{ workflow.name }}
        </li>
      </ul>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { CodeLoader, BulletListLoader } from "vue-content-loader";

export default {
  components: { CodeLoader, BulletListLoader },
  computed: mapGetters(["skills"]),
  methods: mapActions(["fetchSkills"]),
  created() {
    this.fetchSkills();
  },
};
</script>
